import { GuardedType, isArray, IsInterface, isMissing, isString, isUndefined, isUnion } from "generic-type-guard";

/*
Stores users info relevant to the Fachverfahrens-Portal (used for displaying assignable usernames).
 */
export interface UsersSlice {
	// A list of users available for assignment
	readonly availableUsers: Record<string, readonly AssigneeCandidate[]>;
}

export const isAssigneeCandidate = new IsInterface()
	.withProperties({ username: isString })
	.withOptionalProperties({
		firstName: isMissing(isString),
		lastName: isMissing(isString),
		fullName: isMissing(isString),
		fqns: isArray(isUnion(isString, isUndefined))
	})
	.get();
export type AssigneeCandidate = GuardedType<typeof isAssigneeCandidate>;

export const isAssigneeCandidatesData = isArray(isAssigneeCandidate);
